module.exports = __webpack_public_path__ + "images/walletprotection_old7e897a164a09676ce220b4714c1e3f20.jpg";